// extracted by mini-css-extract-plugin
export default {"arrowBack":"styles_arrowBack__fkYkg","icon":"styles_icon__dUZMq"};